export default __webpack_public_path__ + "static/media/2508116.8ec7ea84.png";